import { Image, Popover } from "antd";

import { Avatar } from "components/UI";
import { randomColors } from "utils/static";
import { generateCardName } from "utils/helper";

const AvatarEmployee = ({ index, name, avatarURL, ...props }) => {
  const content = (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <Image width={200} src={avatarURL} />
    </div>
  );

  return (
    <>
      {avatarURL ? (
        <Popover trigger={["hover"]} content={content}>
          <Avatar
            src={avatarURL}
            className="border-primary border-[1px]"
            {...props}
          />
        </Popover>
      ) : (
        <Avatar
          style={{ backgroundColor: randomColors[index % 10] }}
          {...props}
        >
          {generateCardName(name || "")}
        </Avatar>
      )}
    </>
  );
};

export default AvatarEmployee;
